import useFormal from '@kevinwolf/formal-web'

export function useFormalWithProps(initialValues, params) {
  const formal = useFormal(initialValues, params)
  const formalProps = {
    formal,
    formProps: formal.getFormProps(),
    resetButtonProps: formal.getResetButtonProps(),
    submitButtonProps: formal.getSubmitButtonProps(),
  }

  for (const f in params.schema.fields) {
    formalProps[`${f}Props`] = formal.getFieldProps(f)
  }
  return formalProps
}
